import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MeetingPortal from './MeetingPortal';
import './index.css';
import './mobile.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <MeetingPortal />
  </React.StrictMode>
);
